export default __webpack_public_path__ + "static/media/close.d331cb64.svg";